<template>
    <TheModal class="sm" @close="close">
        <template slot="head">
            {{ $route.meta.title }}
            <a target="_blank" :href="getKBLink('add_ingredients')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                <input v-model="form.name" v-focus type="text" class="form-control" maxlength="60" placeholder="Введите название">
            </ValidationProvider>

            <ValidationProvider v-errors.api vid="unit" tag="div" class="form-group" rules="required">
                <select-unit v-model="form.unit" type="text" class="form-control multiselect-fixed" />
            </ValidationProvider>

            <div class="mt-4 mb-2">
                <div class="lead mb-2">Себестоимость</div>

                <p class="text-muted small">Укажите стоимость упаковки и её объем.<br>Цена за 1 {{ form.unit | unit }} будет рассчитана автоматически.</p>
            </div>

            <template v-if="netPriceEditMode">
                <div class="d-flex align-items-center my-3">
                    <div class="input-group">
                        <input v-model="netPrice" type="number" step="any" class="form-control" min="0" placeholder="Цена" @input="calcNetPrice">
                        <div class="input-group-append">
                            <span id="basic-addon2" class="input-group-text">{{ currency | currencySymbol }}</span>
                        </div>
                    </div>

                    <div class="mx-3">ЗА</div>

                    <div class="input-group">
                        <input v-model="netPriceVolume" type="number" class="form-control" min="0" placeholder="Объем, кол-во" @input="calcNetPrice">
                        <div class="input-group-append">
                            <span id="basic-addon2" class="input-group-text">{{ form.unit | unit }}</span>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="form.net_price === null">
                <div class="d-flex justify-content-between">
                    <div>&nbsp;</div>
                    <button v-show="!netPriceEditMode" type="button" class="btn btn-primary" @click="netPriceEditMode = true">Изменить</button>
                </div>
            </template>

            <template v-else>
                <div class="d-flex justify-content-between">
                    <div v-if="pricePerPacketLabel">
                        {{ pricePerPacketLabel }} <span class="text-muted">= {{ form.net_price }} {{ currency | currencySymbol }} за 1 {{ form.unit | unit }}</span>
                    </div>

                    <div v-else>
                        {{ form.net_price }} {{ currency | currencySymbol }} за 1 {{ form.unit | unit }}
                    </div>

                    <button v-show="!netPriceEditMode" type="button" class="btn btn-primary" @click="netPriceEditMode = true">Изменить</button>
                </div>
            </template>

            <div class="mt-4">
                <button type="submit" class="btn btn-primary btn-lg">{{ form.id ? 'Сохранить' : 'Создать' }}</button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import store from '@/store'
import SelectUnit from '@/components/SelectUnit'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import { toastSuccess } from '@/dialogs'
import cloneDeep from 'lodash/cloneDeep'

import { currencySymbol, unit1000 } from '../../plugins/misc/filters'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        SelectUnit,
        TheModal,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            form: {
                id: null,
                name: null,
                unit: null,
                net_price: null
            },

            netPriceEditMode: true,
            netPrice: '',
            netPriceVolume: 1000
        }
    },

    computed: {
        currency() {
            return this.$store.state.company.profile.data.currency || null
        },

        pricePerPacketLabel() {
            if (this.form.unit === 1) { // Работаем только с гр - кг, мл - л
                return null
            }

            let netPrice1000 = this.form.net_price * 1000
            netPrice1000 = Math.round(netPrice1000 * 10000) / 10000

            return `${netPrice1000}` + ' ' + currencySymbol(this.currency) + ' за 1 ' + unit1000(this.form.unit)
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'stocks.components' })
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const done = await this.$store.dispatch('components/store', this.form)

            if (done) {
                this.close()
                toastSuccess(this.form.id ? 'Ингредиент сохранен' : 'Ингредиент создан')
            } else {
                mixinApiErrors(this.$refs.obs, this.$store.state.stocks.error)
            }
        },

        calcNetPrice() {
            if (this.netPrice && this.netPrice > 0 && this.netPriceVolume && this.netPriceVolume > 0) {
                const price = this.netPrice / this.netPriceVolume

                this.form.net_price = Math.round(price * 10000) / 10000

                if (this.form.net_price <= 0) {
                    this.form.net_price = null
                }
            } else {
                this.form.net_price = null
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        if (!to.params.id) {
            return next()
        }

        const component = await store.dispatch('components/fetchById', parseInt(to.params.id))

        if (component) {
            return next(vm => {
                vm.form = cloneDeep(component)
            })
        }

        return next({ name: 'stocks.components' })
    }
}
</script>
